/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MatchCompetency } from '../../models/match-competency';

export interface UpdateMatchCompetency$Params {
  id: string;
      body?: MatchCompetency
}

export function updateMatchCompetency(http: HttpClient, rootUrl: string, params: UpdateMatchCompetency$Params, context?: HttpContext): Observable<StrictHttpResponse<MatchCompetency>> {
  const rb = new RequestBuilder(rootUrl, updateMatchCompetency.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<MatchCompetency>;
    })
  );
}

updateMatchCompetency.PATH = '/matchcompetency/{id}';
